import { gql } from '@oneaudi/onegraph-service';
export const CARLINE_QUERY = gql `
  query CarlineForCae($identifier: CarlineIdentifierInput!) {
    carline(identifier: $identifier) {
      name
      consumptionAndEmission {
        summary {
          consumption
          emissionCO2
          dischargedCO2Class
          dischargedConsumption
          co2Class
        }
      }
    }
  }
`;
//# sourceMappingURL=carlineQuery.js.map